import {
    PRODUCTSLIST_REQUEST,
    PRODUCTSLIST_ERROR,
    PRODUCTSLIST_SUCCESS,
    PRODUCTSLIST_params,
} from "../actions/productsList";
import {
    RETURNGOODSLIST_SUCCESS
} from "../actions/returnGoodsList";
import {
    EXTRALIST_SUCCESS
} from "../actions/extraList";
import apiCalls from "utils/api";

const state = {
    status: ""
};

const actions = {
    [PRODUCTSLIST_REQUEST]: ({ commit }) => {
        commit(PRODUCTSLIST_REQUEST);
        apiCalls.apiCall({ url: "get", method: "GET", params: PRODUCTSLIST_params })
            .then(resp => {
                commit(PRODUCTSLIST_SUCCESS, resp.data);
                commit(RETURNGOODSLIST_SUCCESS, resp.data);
                commit(EXTRALIST_SUCCESS, resp.data);       
            })
            .catch(() => {
                commit(PRODUCTSLIST_ERROR);
            });
    }
};

const mutations = {
    [PRODUCTSLIST_REQUEST]: state => {
        state.status = "loading";
    },
    [PRODUCTSLIST_SUCCESS]: (state, resp) => {
        state.status = "success";
    },
    [PRODUCTSLIST_ERROR]: state => {
        state.status = "error";
    }
};

export default {
    state,
    actions,
    mutations
};